import { CloseIcon } from "@/Icons/Close";
import { AlertType } from "@/States/globalAlert";
import { Translate, useTrans } from "@/translations";

import React, { useMemo } from "react";

import { twMerge } from "tailwind-merge";

import { alertConfig } from "./alertLineConfig";

export const AlertLine = ({
  type,
  message,
  messageVariables,
  instructions,
  instructionVariables,
  instructionComponents,
  close,
  canClose = true,
  isStatic = false,
}: {
  type: AlertType;
  message: string;
  messageVariables?: { [key: string]: string };
  instructions?: string;
  instructionVariables?: { [key: string]: string };
  instructionComponents?: React.ReactElement[];
  close?: () => void;
  canClose?: boolean;
  isStatic?: boolean;
}) => {
  const { t } = useTrans();
  const config = useMemo(() => alertConfig[type], [type]);

  return (
    <div
      className={twMerge(
        "relative flex w-full items-center p-4 shadow-md",
        isStatic ? "shadow-none" : "border-2",
        config.className,
      )}
    >
      <div className="absolute top-5">{config.icon}</div>
      <div className="pr-3 pl-10 text-base">
        <div
          className={
            isStatic ? "text-sm font-normal text-black" : "font-medium"
          }
        >
          {t(message, messageVariables)}
        </div>
        {instructions && (
          <div className="mt-2 font-normal">
            <Translate
              i18nKey={instructions}
              components={instructionComponents}
              values={instructionVariables}
            />
          </div>
        )}
      </div>
      {canClose && (
        <div className="pointer absolute top-4 right-4" onClick={close}>
          <CloseIcon />
        </div>
      )}
    </div>
  );
};
